module.exports = __webpack_public_path__ + "img/mail.80d5e7c7.svg";